import { useParams, useSearchParams } from 'react-router-dom';
import BackToGameLink from '../components/BackToGameLink';
import BoxScorePanel from '../components/BoxScorePanel';
import TopBar from '../components/TopBar';
import { gameModeFromSearch, useGameStream } from '../hooks/useGameStream';
import styles from './SubPages.module.css';

export default function BoxScorePage(): JSX.Element {
  const { gamePk } = useParams();
  const [searchParams] = useSearchParams();
  const gamePkNum = gamePk ? Number(gamePk) : undefined;
  // Historical games render from a one-shot snapshot instead of opening a
  // live SSE stream on a final game.
  const mode = gameModeFromSearch(searchParams);
  const { snapshot, status, statcast } = useGameStream(gamePkNum, { mode });

  return (
    <>
      <TopBar />
      <main className={styles.page}>
        <div className={styles.pageHeader}>
          <BackToGameLink gamePk={gamePkNum} mode={mode} />
          <h1 className={styles.title}>Box score</h1>
        </div>
        {status === 'connecting' && !snapshot && <p>Loading…</p>}
        <BoxScorePanel snapshot={snapshot} gamePk={gamePkNum} statcast={statcast?.pitches} />
      </main>
    </>
  );
}
